import { getCID } from '../../../lib';
import Api from "../../../lib/api";
import CourseHelpPopup from "../../page-modules/course-entry/course-help-popup";
import Consent from "../../../components/consent";

export default class Analytics {
	constructor() {
		this.init();
	}

	init() {
		this.initConsent();
		this.analyticsRequest();
	}

	initConsent() {
		new Consent();
	}

	analyticsRequest() {
		const gacid = getCID();
		const courseCategory = craft.page.courseCategory;

		const data = {
			"cid": gacid,
			"url": window.location.href
		};

		if (courseCategory) {
			data['courseCategory'] = courseCategory;
		}

		Api.post(Api.restSiteUrl + '/1.0/analytics/add', JSON.stringify(data))
			.then(({ data }) => {
				if (
					!window.matchMedia('(min-width: 769px)').matches ||
					craft.page.handle !== 'courses-entry'
				) return;

				if (courseCategory == 'kids' && data.proftestRecKids == 1) {
					new CourseHelpPopup({
						id: 'kidsCourseRecommendation',
						cookieName: 'h_proftestRecKids',
						dataLayerEvent: 'recommended_teen_course_button'
					});
				} else if (data.proftestRec == 1) {
					new CourseHelpPopup({
						id: 'profTestRecommendation',
						cookieName: 'h_proftestRec',
						dataLayerEvent: 'popup_proftest_show'
					});
				}
			})
			.catch(err => {
				console.error('Request error ', err);
			});
	}
}



